// extracted by mini-css-extract-plugin
export default {"container":"boxChart_container__OOllW"};